(function () {
  'use strict';

  var formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

  function number(value) {
    var parsed = Number(value);
    return Number.isSafeInteger(parsed) ? parsed : NaN;
  }

  function read(root) {
    var node = root.querySelector('[data-ers-order-distribution-data]');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      if (!data || !data.population || data.population.fulfilledOrders !== 8650 || !Array.isArray(data.bins) || data.bins.length !== 7) return null;
      if (!data.binRule || data.binRule.mainUpperExclusive !== 60000 || data.binRule.tailOpen !== true) return null;
      if (!data.quartiles || !Number.isFinite(data.quartiles.q25) || !Number.isFinite(data.quartiles.median) || !Number.isFinite(data.quartiles.q75)) return null;
      if (data.bins.some(function (bin) { return !Number.isFinite(bin.orderShare) || !Number.isFinite(bin.displayPercent); })) return null;
      return data;
    } catch (error) {
      return null;
    }
  }

  function element(name, className, text) {
    var node = document.createElement(name);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function marker(label, value, className, left) {
    var node = element('span', 'ers-order-distribution__marker ' + className);
    node.style.left = left + '%';
    node.appendChild(element('b', '', label));
    node.appendChild(element('small', '', formatter.format(value)));
    return node;
  }

  function shortBinLabel(bin) {
    if (bin.maxExclusive === null) return Math.round(bin.minInclusive / 1000) + 'k+';
    if (bin.minInclusive === 0) return '<' + Math.round(bin.maxExclusive / 1000) + 'k';
    return Math.round(bin.minInclusive / 1000) + '–\u200b' + (Math.round(bin.maxExclusive / 1000) - 1) + 'k';
  }

  function draw(root, data) {
    var plot = root.querySelector('[data-ers-distribution-plot]');
    if (!plot) return;
    plot.textContent = '';

    var scale = element('div', 'ers-order-distribution__scale');
    scale.appendChild(element('span', '', '40%'));
    scale.appendChild(element('span', '', '20%'));
    scale.appendChild(element('span', '', '0'));

    var main = element('div', 'ers-order-distribution__main');
    var bars = element('div', 'ers-order-distribution__bars');
    data.bins.slice(0, 6).forEach(function (bin) {
      var column = element('div', 'ers-order-distribution__bar-column');
      var value = element('strong', '', bin.displayPercent + '%');
      var bar = element('i', 'ers-order-distribution__bar');
      bar.style.height = Math.min(100, (bin.orderShare * 100 / 40) * 100) + '%';
      bar.appendChild(value);
      column.appendChild(bar);
      column.appendChild(element('span', '', shortBinLabel(bin)));
      bars.appendChild(column);
    });
    main.appendChild(bars);

    var markers = element('div', 'ers-order-distribution__markers');
    markers.appendChild(marker('25th', data.quartiles.q25, 'is-q25', data.quartiles.q25 / data.binRule.mainUpperExclusive * 100));
    markers.appendChild(marker('Median', data.quartiles.median, 'is-median', data.quartiles.median / data.binRule.mainUpperExclusive * 100));
    markers.appendChild(marker('75th', data.quartiles.q75, 'is-q75', data.quartiles.q75 / data.binRule.mainUpperExclusive * 100));
    main.appendChild(markers);

    var breakNode = element('div', 'ers-order-distribution__break');
    breakNode.setAttribute('aria-hidden', 'true');
    breakNode.textContent = '//';

    var tailBin = data.bins[6];
    var tail = element('div', 'ers-order-distribution__tail');
    var tailBar = element('i', 'ers-order-distribution__bar');
    tailBar.style.height = Math.min(100, (tailBin.orderShare * 100 / 40) * 100) + '%';
    tailBar.appendChild(element('strong', '', tailBin.displayPercent + '%'));
    tail.appendChild(tailBar);
    tail.appendChild(element('span', '', shortBinLabel(tailBin)));

    plot.appendChild(scale);
    plot.appendChild(main);
    plot.appendChild(breakNode);
    plot.appendChild(tail);
  }

  function describe(value, quantiles) {
    if (value < quantiles.q25) return 'below the 25th-percentile value';
    if (value === quantiles.q25) return 'at the 25th-percentile value';
    if (value < quantiles.median) return 'between the 25th percentile and median';
    if (value === quantiles.median) return 'at the historical median';
    if (value < quantiles.q75) return 'between the median and 75th percentile';
    if (value === quantiles.q75) return 'at the 75th-percentile value';
    return 'above the 75th-percentile value';
  }

  function update(root, rawValue) {
    var data = root._ersDistributionData || read(root);
    var value = number(rawValue);
    if (!data || !(value > 0)) return false;
    root._ersDistributionData = data;
    if (!root.querySelector('.ers-order-distribution__main')) draw(root, data);

    root.querySelectorAll('.ers-order-distribution__comparison-marker').forEach(function (node) { node.remove(); });
    var target;
    var left;
    if (value >= data.binRule.mainUpperExclusive) {
      target = root.querySelector('.ers-order-distribution__tail');
      left = 50;
    } else {
      target = root.querySelector('.ers-order-distribution__main');
      left = value / data.binRule.mainUpperExclusive * 100;
    }
    if (target) target.appendChild(marker(root.dataset.distributionMode === 'applied' ? 'Your plan' : 'Compare', value, 'ers-order-distribution__comparison-marker', left));

    var result = root.querySelector('[data-ers-distribution-result]');
    if (result) {
      var tailText = value >= data.binRule.mainUpperExclusive ? ' It falls in the separated open 60,000-pair-and-above band.' : '';
      result.hidden = false;
      var positionText = formatter.format(value) + ' pairs is ' + describe(value, data.quartiles) + '.' + tailText;
      result.textContent = root.dataset.distributionMode === 'interactive'
        ? positionText
        : positionText + ' This position describes ERS fulfilled-order history, not a recommended quantity.';
    }
    return true;
  }

  function initialize(root) {
    var data = read(root);
    if (!data) {
      root.classList.add('is-data-unavailable');
      return;
    }
    root._ersDistributionData = data;
    draw(root, data);

    var form = root.querySelector('[data-ers-distribution-form]');
    var input = root.querySelector('[data-ers-distribution-input]') || root.querySelector('[data-ers-distribution-control] input');
    if (form && input) {
      var compare = function () {
        var isValid = update(root, input.value);
        input.setAttribute('aria-invalid', isValid ? 'false' : 'true');
        if (!isValid) {
          var result = root.querySelector('[data-ers-distribution-result]');
          if (result) {
            result.hidden = false;
            result.textContent = 'Enter a fulfilled-order quantity greater than zero to compare.';
          }
        }
      };
      form.addEventListener('submit', function (event) { event.preventDefault(); compare(); });
      input.addEventListener('change', compare);
      compare();
    }
  }

  function initializeAll() {
    document.querySelectorAll('[data-ers-order-distribution]').forEach(initialize);
  }

  window.ERSOrderDistribution = { update: update, initialize: initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();
}());
